import { useSymbolsStore } from '../store/Symbols';
import { useSymbolsRender } from '../utils/useRender';
export var BraceRight = props => {
  var {
    BraceRight: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'BraceRight');
  return null;
};
BraceRight.displayName = 'JVR.BraceRight';